import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  getKeys(): string[] {
    return Object.keys(sessionStorage);
  }

  getItem<T = any>(key: string): T {
    const value = sessionStorage.getItem(key);
    try {
      return JSON.parse(value!);
    } catch (e) {
      return value as unknown as T;
    }
  }

  setItem<T>(key: string, value: T): void {
    if (value == null) {
      this.removeItem(key);
      return;
    }
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  removeItems(keys: string[]): void {
    keys.forEach((key) => this.removeItem(key));
  }

  trigger<T = any>(key: string, value: T | boolean = true): void {
    this.setItem(key, value);
    this.removeItem(key);
  }

  clear(exclude: string[] = []) {
    this.getKeys().forEach((key) => {
      if (!exclude.includes(key)) {
        this.removeItem(key);
      }
    });
  }

  hasKey(key: string): boolean {
    return this.getKeys().includes(key);
  }
}
